import React, { useState , useEffect} from "react";
import {Box, Drawer, ListItem, ListItemText, List, Collapse } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import appLogo from "../../../../assets/images/app-logo.png";
import i18next from "i18next";



const Navbar = ({ onLogout, navigationItems, isDrawerOpen, onSetDrawerOpen }) => {
  const [activeItem, setActiveItem] = useState({
    parent: "Dashboard",
    child: null,
  });
  const navigate = useNavigate();
      // Function to handle closing the drawer
      const handleNavigationClick = (item) => {
        setActiveItem({ parent: item.label, child: null });
        // setDrawerOpen(false); // Close drawer on navigation item click
        if (item.link) navigate(item.link); // Navigate to the link
      };

  const [expanded, setExpanded] = useState(null);

  const toggleExpand = (event, label) => {
    setExpanded((prev) => (prev === label ? null : label));
  };

  useEffect(()=>{
    console.log('navigation items inside sidebar for small screen', navigationItems)
  },[navigationItems])
  return (
    // <AppBar
    //   position="static"
    //   sx={{ backgroundColor: "white", boxShadow: "none" }}
    // >
    //   <Toolbar sx={{ display: "flex", justifyContent: "center" }}>
    //     <Box sx={{ display: "flex", gap: { xs: 1, sm: 3 } }}>
    //       {navLinks?.length > 0 &&
    //         navLinks?.map((item, index) => (
    //           <Typography
    //             key={index}
    //             variant="body2"
    //             sx={{
    //               fontSize: width > 900 ? "14px" : width > 600 ? "12px" : "9px",
    //               fontWeight: width > 900 ? 500 : 300,
    //             }}
    //           >
    //             <Link
    //               to={item?.link} // Convert item to a valid route
    //               style={{
    //                 textDecoration: "none",
    //                 color: "black",
    //                 cursor: "pointer",
    //               }}
    //             >
    //               {item?.label}
    //             </Link>
    //           </Typography>
    //         ))}
    //     </Box>
    //   </Toolbar>
    // </AppBar>
    <Drawer
    anchor="left"
    open={isDrawerOpen}
    onClose={() => onSetDrawerOpen(false)} // Close the drawer on outside click
  >
    <Box
      sx={{
        width: 250, // Adjust width to match design
        padding: "20px 15px",
      }}
      role="presentation"
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 80, // Space for the logo
          marginBottom: "20px",
          marginLeft: "-35%",
        }}
      >
        <img
          src={appLogo}
          alt="App Logo"
          style={{ maxHeight: 50, objectFit: "contain" }}
        />
      </Box>

      <List>
        {navigationItems?.map((item) => (
          <React.Fragment key={item.label}>
            <ListItem
              button
              component={Link}
              to={item.link}
              onClick={() => handleNavigationClick(item)} // Handle navigation click
              sx={{
                color:
                  activeItem.parent === item.label ? "#3173B1" : "#868686",
                fontSize: "16px",
                fontFamily:
                  activeItem.parent === item.label
                    ? "Tajawal-Bold"
                    : "Tajawal-Regular",
                 
              }}
            >
              {/* <img
                src={
                  activeItem.parent === item.label
                    ? item.activeIcon
                    : item.icon
                }
                alt={item.label}
                style={{
                  marginRight: "10px",
                  width: "20px",
                  height: "20px",
                }}
              /> */}
              <ListItemText
                primary={item.label}
                primaryTypographyProps={{
                  fontSize: "16px",
                  fontFamily: "Tajawal-Regular",
                  marginTop:"-5%",
                }}
              />
              {item.children &&
                (expanded === item.label ? (
                  <ExpandLess
                    onClick={(event) => toggleExpand(event, item.label)}
                  />
                ) : (
                  <ExpandMore
                    onClick={(event) => toggleExpand(event, item.label)}
                  />
                ))}
            </ListItem>

            {item.children && (
              <Collapse
                in={expanded === item.label}
                timeout="auto"
                unmountOnExit
              >
                <List component="div" disablePadding>
                  {item.children.map((child) => (
                    <ListItem
                      button
                      component={Link}
                      to={child.link}
                      key={child.label}
                      onClick={() => {
                        setActiveItem({
                          parent: item.label,
                          child: child.label,
                        });
                      }}
                      sx={{
                        color:
                          activeItem.child === child.label
                            ? "#3173B1"
                            : "#868686",
                        fontSize: "16px",
                        fontFamily:
                          activeItem.child === child.label
                            ? "Tajawal-Bold"
                            : "Tajawal-Regular",
                        pl: 4,
                      }}
                    >
                      <ListItemText
                        primary={child.label}
                        primaryTypographyProps={{
                          fontSize: "16px",
                          fontFamily: "Tajawal-Regular",
                        }}
                      />
                    </ListItem>
                  ))}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        ))}
        <ListItem>
          <ListItemText
            primary={i18next.t("Logout")}
            primaryTypographyProps={{
              fontSize: "16px",
              fontFamily: "Tajawal-Regular",
              color:"#868686"
            }}
            onClick={onLogout}
          ></ListItemText>
        </ListItem>
      </List>
    </Box>
  </Drawer>
  );
};

export default Navbar;
